import { FC, PropsWithChildren } from 'react';
import { StyledTextSpan } from './styles';

const TextAdornment: FC<PropsWithChildren<{ text?: string }>> = ({
  text,
  children,
  ...props
}) => {
  return <StyledTextSpan {...props}>{children || text}</StyledTextSpan>;
};

export default TextAdornment;
